import script from "./productDealsResult.vue?vue&type=script&lang=jsx&setup=true"
export * from "./productDealsResult.vue?vue&type=script&lang=jsx&setup=true"

import "./productDealsResult.vue?vue&type=style&index=0&id=065f2c33&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065f2c33"]])

export default __exports__